<template>
  <div class="flex pl-4 items-center cursor-pointer" @click="exportResults">
    <DownloadIcon fill="#007F80" />
    <label class="font-montserrat font-medium text-teal-900 cursor-pointer">CSV</label>
  </div>
</template>
<script setup>
import { useToast } from "vue-toast-notification";
import * as Sentry from "@sentry/vue";
import { format as formatDate } from "date-fns";
import { useSearchClient } from "@/composables/useSearchClient";
import { getApiClientWithAuth } from "@/services/API";
import DownloadIcon from "@/components/shared/icons/DownloadIcon.vue";

const toast = useToast();

const { currentConfig, queryParams, fixupPayload } = useSearchClient();

const exportResults = async () => {
  try {
    const baseUrl = currentConfig().proxyConfig.base;
    const exportQuery = currentConfig().proxyConfig.export;
    const response = await getApiClientWithAuth(baseUrl).post(`${exportQuery}/${queryParams()}`, fixupPayload());

    if (!response.status === 200) {
      toast.open({
        type: "error",
        message: "Failed to download student export data",
        position: "bottom-right",
        duration: 3000,
      });
      Sentry.captureException(response.statusText, {
        tags: {
          feature: "mystudents",
          action: "csv_export",
        },
      });
      throw new Error("Failed to download file.");
    }
    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    const filename = `APIC-My-Students-${formatDate(new Date(), "MM-dd-yyyy")}.csv`;
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    toast.open({
      type: "success",
      message: `Successfully downloaded export file - ${filename}`,
      position: "bottom-right",
      duration: 3000,
    });
  } catch (error) {
    toast.open({
      type: "error",
      message: "Failed to export student data",
      position: "bottom-right",
      duration: 3000,
    });
    Sentry.captureException(error, {
      tags: {
        feature: "mystudents",
        action: "csv_export",
      },
    });
  }
};
</script>
